import { render, staticRenderFns } from "./forgetPass.vue?vue&type=template&id=5c38a7b2&"
import script from "./forgetPass.vue?vue&type=script&lang=js&"
export * from "./forgetPass.vue?vue&type=script&lang=js&"
import style0 from "./forgetPass.vue?vue&type=style&index=0&id=5c38a7b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports